import React, { useEffect, useState } from 'react'
import Layout from '../../Components/Layout'
import { Icon } from "@iconify/react";
import '../../Assets/CSS/Offboarding.css'
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import toast from 'react-hot-toast';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


export const getUserRole = (token) => {
  try {
    const decoded = jwtDecode(token);
    console.log("Decoded JWT:", decoded);

    const roles = decoded.roles || [];   // roles array from token
    const userName = decoded.userName || decoded.sub || null; // subject claim

    // Expiration (exp is in seconds, convert to ms)
    const expiryTime = decoded.exp ? decoded.exp * 1000 : null;

    return { roles, userName, expiryTime };
  } catch (error) {
    console.error("Invalid token", error);
    return { roles: [], userName: null, expiryTime: null };
  }
};

const Offboarding = () => {

  const [employeeList, setEmployeeList] = useState([]);
  const [showEmployeeDropdown, setShowEmployeeDropdown] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [offboardingCounts, setOffboardingCounts] = useState({
  activeOffboardingRequests: 0,
  completedOffboardingRequests: 0,
  notInitiatedOffboardingRequests: 0,
});

const fetchOffboardingCounts = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/offboarding-requests-count`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setOffboardingCounts(response.data);
  } catch (error) {
    console.error("Error fetching offboarding counts", error);
  }
};

  const searchEmployee = async (value) => {
    if (!value || value.length < 2) {
      setEmployeeList([]);
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/search-by-name`,
        {
          params: { empName: value },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setEmployeeList(response.data || []);
      setShowEmployeeDropdown(true);
    } catch (error) {
      console.error("Employee search failed", error);
    }
  };


  const [allOffboardings, setAllOffboardings] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  const [showReasonDropdown, setShowReasonDropdown] = useState(false);
  const [errors, setErrors] = useState({});


  const [formData, setFormData] = useState({
    employee: "",
    lastWorkingDay: "",
    offboardingType: "Resignation",
    reason: "",
    notes: "",
    assets: "",
  });



  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    // Remove error for the specific field when user types
    setErrors(prev => ({
      ...prev,
      [name]: "",
    }));
  };




  const navigate = useNavigate();








  const reasonOptions = [
    "Better Opportunity",
    "Personal Reasons",
    "Relocation",
    "Workload Issues",
    "Health Reasons",
    "Termination - Policy Violation",
    "Termination - Performance",
  ];





  const token = localStorage.getItem("token");
  console.log("offBoarding : ", token)
  const { roles = [] } = getUserRole(token);

  console.log("off-roles : ", roles)

  // const getRoleLabel = () => {
  //   if (roles.includes("ROLE_HR")) return "HR";
  //   if (roles.includes("ROLE_MANAGER")) return "Manager";
  //   if (roles.includes("ROLE_ADMIN")) return "Admin";
  //   if (roles.includes("ROLE_FINANCE")) return "FINANCE";
  //   if (roles.includes("ROLE_IT_MANAGER")) return "IT";
  //   return "";
  // };

  const getRoleLabel = () => {
  const labels = [];
  if (roles.includes("ROLE_HR")) labels.push("HR");
  if (roles.includes("ROLE_MANAGER")) labels.push("Manager");
  if (roles.includes("ROLE_ADMIN")) labels.push("Admin");
  if (roles.includes("ROLE_FINANCE")) labels.push("Finance");
  if (roles.includes("ROLE_IT_MANAGER")) labels.push("IT");

  return labels.join(" | ");
};


  const getStatusStyle = (status) => {
  // Yellow (Pending – manager / initial)
  if (
    status === "PENDING" ||
    status === "PENDING_MANAGER_APPROVAL"
  ) {
    return {
      bg: "#FFFED9",
      color: "#A39D00",
    };
  }

  // Blue (In progress – HR / IT / Finance / workflow)
  if (
    status === "PENDING_HR_APPROVAL" ||
    status === "PENDING_IT_APPROVAL" ||
    status === "PENDING_FINANCE_APPROVAL" ||
    status === "IN_PROGRESS"
  ) {
    return {
      bg: "#E5E8FF",
      color: "#0010A3",
    };
  }

  // Green (Completed)
  if (status === "COMPLETED") {
    return {
      bg: "#E0FFEC",
      color: "#22C55E",
    };
  }

  // Default fallback
  return {
    bg: "#F2F2F2",
    color: "#606060",
  };
};


  // Status Badge Style
  const statusStyles = {
    pending: {
      bg: "#FFFACD",
      color: "#A68B00",
      label: "Pending Manager Approval",
    },
    "in-progress": {
      bg: "#E8E6FF",
      color: "#4A50FF",
      label: "In progress",
    },
  };

  const LightDark = {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    color: '#303030'
  };
  const mainHead = {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    color: '#606060'
  };
  const pTag = {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: '12px',
    color: '#909090'
  };
  const cards = {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: '14px',
    color: '#808080'
  };





  const validate = () => {
    let newErrors = {};

    if (!formData.employee.trim()) {
      newErrors.employee = "Employee is required";
    }
    if (!formData.lastWorkingDay) {
      newErrors.lastWorkingDay = "Last working day is required";
    }
    if (!formData.reason.trim()) {
      newErrors.reason = "Reason is required";
    }

    if (!selectedEmployee) {
      newErrors.employee = "Please select employee from list";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };




  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      const token = localStorage.getItem("token");

      const payload = {
        employeeId: selectedEmployee.empId,
        lastWorkingDay: formData.lastWorkingDay,
        offboardingType: formData.offboardingType,
        reason: formData.reason,
        additionalNotes: formData.notes,
      };

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/create`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Offbooarding Request Created")
      // success reset
      setOpenModal(false);
      setFormData({
        employee: "",
        lastWorkingDay: "",
        offboardingType: "Resignation",
        reason: "",
        notes: "",
      });
      setSelectedEmployee(null);

    } catch (error) {
      toast.error("Offbooarding Request not Created")
      console.error("Offboarding creation failed", error);
    }
  };



  //Get Api

  const fetchActiveOffboardings = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/active`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setAllOffboardings(response.data || []);
    } catch (error) {
      console.error("Error fetching active offboardings", error);
    }
  };

  useEffect(() => {
    fetchActiveOffboardings();
    fetchOffboardingCounts();
  }, []);


// priority order (top = highest)
const ROLE_PRIORITY = [
  "ROLE_HR",
  "ROLE_MANAGER",
  "ROLE_IT_MANAGER",
  "ROLE_FINANCE",
  "ROLE_ADMIN",
  "ROLE_EMP"
];

  const activeRole = ROLE_PRIORITY.find(role => roles.includes(role));



  // ===================== EMPLOYEES DATA =====================



//   const handleProgress = (offboardingId) => {
//   if (activeRole === "ROLE_HR") {
//     navigate(`/off-boardingDetails/${offboardingId}`);
//   } 
//   else if (
//     activeRole === "ROLE_MANAGER" ||
//     activeRole === "ROLE_IT_MANAGER" ||
//     activeRole === "ROLE_FINANCE"
//   ) {

//       navigate(`/off-boarding/profile-detail/${offboardingId}`)

//   }
// };

const handleViewRequest = (offboardingId) => {
  // Manager, IT, Finance
  if (
    roles.includes("ROLE_MANAGER") ||
    roles.includes("ROLE_IT_MANAGER") ||
    roles.includes("ROLE_FINANCE")
  ) {
    navigate(`/off-boarding/profile-detail/${offboardingId}`);
  }
};

const handleViewStatus = (offboardingId) => {
  // HR & Manager
  if (
    roles.includes("ROLE_HR") ||
    roles.includes("ROLE_MANAGER")
  ) {
    navigate(`/off-boardingDetails/${offboardingId}`);
  }
};



const getApprovalIcon = (decision) => {
  if (decision === "APPROVED" || decision === "COMPLETED") {
    return (
      <Icon
        icon="weui:done2-outlined"
        color="#29C46D"
        width="18"
      />
    );
  }

  return (
    <Icon
      icon="weui:time-outlined"
      color="#B29419"
      width="18"
    />
  );
};

const calculateOverallProgress = (emp) => {
  // base tasks (IT + Finance etc)
  const taskTotal = emp.totalTasks || 0;
  const taskCompleted = emp.completedTasks || 0;

  // approvals to include
  const approvalRoles = ["ROLE_HR", "ROLE_MANAGER"];

  let approvalTotal = approvalRoles.length;
  let approvalCompleted = 0;

  approvalRoles.forEach(role => {
    const approval = emp.approvals?.find(a => a.approverRole === role);
    if (approval && approval.decision === "APPROVED") {
      approvalCompleted++;
    }
  });

  const total = taskTotal + approvalTotal;
  const completed = taskCompleted + approvalCompleted;

  const percentage =
    total > 0 ? Math.round((completed / total) * 100) : 0;

  return {
    total,
    completed,
    percentage,
  };
};

const getPendingApprovalCount = () => {
  if (!allOffboardings || allOffboardings.length === 0) return 0;

  let pendingStatus = "";

  if (roles.includes("ROLE_HR")) {
    pendingStatus = "PENDING_HR_APPROVAL";
  } else if (roles.includes("ROLE_MANAGER")) {
    pendingStatus = "PENDING_MANAGER_APPROVAL";
  } else if (roles.includes("ROLE_IT_MANAGER")) {
    pendingStatus = "PENDING_IT_APPROVAL";
  } else if (roles.includes("ROLE_FINANCE")) {
    pendingStatus = "PENDING_FINANCE_APPROVAL";
  }

  return allOffboardings.filter(
    (item) => item.status === pendingStatus
  ).length;
};

  const cardData = [
    {
      id: 1,
      title: "Pending Approvals",
      count: getPendingApprovalCount(),
      bg: "#FFFEE6",
      icon: "mingcute:time-line",
      color: "#D4D300",
    },
    {
      id: 2,
      title: "Active Offboardings",
      count:  offboardingCounts.activeOffboardingRequests,
      bg: "#F9ECFF",
      icon: "material-symbols:group-outline",
      color: "#C646F5",
    },
    {
      id: 3,
      title: "HR Initiation Pending",
      count: offboardingCounts.notInitiatedOffboardingRequests,
      bg: "#EAF2FF",
      icon: "mynaui:flag",
      color: "#4A77F3",
    },
    {
      id: 4,
      title: "Completed This Month",
      count: offboardingCounts.completedOffboardingRequests,
      bg: "#E8FFEE",
      icon: "lets-icons:done-ring-round",
      color: "#2FB463",
    },
  ];

  const getActiveOffboardingsByRole = () => {
  if (!allOffboardings || allOffboardings.length === 0) return [];

  let allowedStatus = [];

  if (roles.includes("ROLE_HR")) {
    allowedStatus = [ 
      "PENDING_HR_APPROVAL",
      "PENDING_MANAGER_APPROVAL",
      "PENDING_IT_APPROVAL",
      "PENDING_FINANCE_APPROVAL"
    ];
  } else if (roles.includes("ROLE_MANAGER")) {
    allowedStatus = [ 
      "PENDING_HR_APPROVAL",
      "PENDING_MANAGER_APPROVAL",
      "PENDING_IT_APPROVAL",
      "PENDING_FINANCE_APPROVAL"
    ];
  } else if (roles.includes("ROLE_IT_MANAGER")) {
    allowedStatus = ["PENDING_IT_APPROVAL"];
  } else if (roles.includes("ROLE_FINANCE")) {
    allowedStatus = ["PENDING_FINANCE_APPROVAL"];
  } else {
    // fallback (Admin or others → see all)
    allowedStatus = [
      "PENDING_HR_APPROVAL",
      "PENDING_MANAGER_APPROVAL",
      "PENDING_IT_APPROVAL",
      "PENDING_FINANCE_APPROVAL",
      "IN_PROGRESS",
      "COMPLETED",
    ];
  }

  return allOffboardings.filter(item =>
    allowedStatus.includes(item.status)
  );
};

  return (
    <Layout>
      <div className="backgound-main-content">
        <div className="leave-management-container ">
          <div className='p-3'>
            <p style={{ fontSize: '22px', fontWeight: 600, }}>Offboarding <span style={{ color: '#909090', fontSize: '22px', fontWeight: 600, }}>    {getRoleLabel()}</span> </p>
          </div>


          <div className="row g-3">

            {cardData.map((item) => (
              <div
                className="col-12 col-sm-6 col-md-6 col-lg-3"
                key={item.id}
              >
                <div
                  className="p-3 shadow-sm h-100"
                  style={{
                    borderRadius: "14px",
                    background: "#fff",
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                  }}
                >
                  {/* Icon box */}
                  <div
                    style={{
                      background: item.bg,
                      padding: "12px",
                      borderRadius: "12px",
                      flexShrink: 0,   // prevents icon from shrinking on small screens
                    }}
                  >
                    <Icon
                      icon={item.icon}
                      width="26"
                      height="26"
                      color={item.color}
                    />
                  </div>

                  {/* Text section */}
                  <div style={{ minWidth: 0 }}>
                    <p
                      className="text-truncate"
                      style={{
                        ...cards, margin: '0px'
                      }}
                    >
                      {item.title}
                    </p>

                    <p
                      style={{
                        margin: 0,
                        fontSize: "22px",
                        fontWeight: 600
                      }}
                    >
                      {item.count}
                    </p>
                  </div>
                </div>
              </div>
            ))}

          </div>



          <div className="mt-5">
            <div className="container mt-3">


              {/* Replace your heading + button block with this */}
              <div className="d-flex align-items-center justify-content-between" style={{ marginTop: '10px' }}>
                <div>
                  <p style={{ ...mainHead, margin: 0 }}>Active Offboarding</p>
                </div>

                <div>
                    {roles.includes("ROLE_HR") && (
                  <button className="add-emp-button" onClick={() => setOpenModal(true)}>
                    <Icon icon="material-symbols:add-rounded" width="18" height="18" />
                    <span className="button-text">New Offboarding</span>
                  </button>
                    )}
                </div>
              </div>



              {/* ============== DYNAMIC CARD LOOP ============== */}
              {/* {allOffboardings.map((emp, index) => { */}
              {getActiveOffboardingsByRole().map((emp, index) => {

  // const isProgress = emp.status === "PENDING_MANAGER_APPROVAL";
  const isProgress = [
  "PENDING_MANAGER_APPROVAL",
  "PENDING_IT_APPROVAL",
  "PENDING_FINANCE_APPROVAL",
  "IN_PROGRESS",
  "PENDING_HR_APPROVAL",
  "COMPLETED"
].includes(emp.status);


  const statusKey =
    emp.status === "PENDING_MANAGER_APPROVAL" ? "in-progress" : "pending";

                const status = statusStyles[statusKey];

                return (
                  <div
                    key={index}
                    className="p-3 mt-3 activeOnboard border"
                    style={{ borderRadius: "8px" }}
                  >

                    {/* Top Row: Left Content + Arrow Right */}
                    <div className="row">
                      <div className="col-10 col-md-12">

                        {/* Employee Name + Status */}
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">

                          <div className="d-flex flex-wrap align-items-center gap-2">
                            <p className="m-0 fw-semibold" style={{ ...LightDark }}>
                              {emp.employeeName}
                            </p>

                            {(() => {
  const statusStyle = getStatusStyle(emp.status);
  return (
    <span
      className="px-3 py-1 rounded-pill"
      style={{
        backgroundColor: statusStyle.bg,
        color: statusStyle.color,
        fontSize: "13px",
        fontWeight: 500,
      }}
    >
      {emp.status}
    </span>
  );
})()}
                          </div>
                          {/* RIGHT: ACTION BUTTONS */}
                          {/* <div className="d-flex gap-2">
                            <button className="admin-add-employee-btn"
                              onClick={() => handleProgress(emp.requestId)}>
                              View Request
                            </button>

                         
                           {roles.includes("ROLE_MANAGER") && (
                              <button
                                className="admin-add-employee-btn"
                                onClick={() => navigate(`/off-boardingDetails/${emp.requestId}`)}
                              >
                                View Status
                              </button>
                            )}
                          </div> */}
                          <div className="d-flex gap-2">

  {/* View Request */}
  {(roles.includes("ROLE_MANAGER") ||
    roles.includes("ROLE_IT_MANAGER") ||
    roles.includes("ROLE_FINANCE")) && (
    <button
      className="admin-add-employee-btn"
      onClick={() => handleViewRequest(emp.requestId)}
    >
      View Request
    </button>
  )}

  {/* View Status */}
  {(roles.includes("ROLE_MANAGER") ||
    roles.includes("ROLE_HR")) && (
    <button
      className="admin-add-employee-btn"
      onClick={() => handleViewStatus(emp.requestId)}
    >
      View Status
    </button>
  )}

</div>


                        </div>
                        {/* Details */}
                        <div className="d-flex flex-wrap gap-3 mt-2 " style={{ fontSize: "14px" }}>
                          <p className="m-0" style={{ ...pTag }}>ID: {emp.employeeCode}</p>
                          <p className="m-0" style={{ ...pTag }}>Post: {emp.designation}</p>
                          <p className="m-0" style={{ ...pTag }}>Dept: {emp.department}</p>
                          <p className="m-0" style={{ ...pTag }}>LWD: {emp.lastWorkingDay}</p>
                          <p className="m-0" style={{ ...pTag }}>Reason: {emp.reason}</p>
                        </div>

                        {/* Progress section */}
                        {isProgress && (
                          <>
                           <p className="mt-3 mb-1">Overall Progress</p>


{(() => {
  const progress = calculateOverallProgress(emp);

  return (
    <>
      <div className="progress" style={{ height: "6px" }}>
        <div
          className="progress-bar"
          style={{
            width: `${progress.percentage}%`,
            backgroundColor: "#00A8FF",
          }}
        />
      </div>

      <p className="text-end mt-1 text-secondary" style={{ fontSize: "13px" }}>
        {progress.completed}/{progress.total} Tasks
      </p>
    </>
  );
})()}


                            {/* HR, IT, Admin, Finance */}
                          
                            <div className="d-flex flex-wrap gap-3">
      <p className="m-0">
    HR {getApprovalIcon(
      emp.approvals?.find(a => a.approverRole === "ROLE_HR")?.decision
    )}
  </p>                          
  <p className="m-0">
    Manager {getApprovalIcon(
      emp.approvals?.find(a => a.approverRole === "ROLE_MANAGER")?.decision
    )}
  </p>

  <p className="m-0">
    IT {getApprovalIcon(
      emp.approvals?.find(a => a.approverRole === "ROLE_IT_MANAGER")?.decision
    )}
  </p>

  <p className="m-0">
    Finance {getApprovalIcon(
      emp.approvals?.find(a => a.approverRole === "ROLE_FINANCE")?.decision
    )}
  </p>
</div>

                          </>
                        )}

                      </div>

                      {/* Arrow button */}
                      {/* <div className=" d-flex justify-content-end align-items-start">
                        <button
                          onClick={() => handleProgress(emp.requestId)}
                          className="btn p-0">
                          View Request
                        </button>
                      </div> */}

                    </div>
                  </div>

                );
              })}
            </div>
          </div>


          {/* Modal Background */}
          {openModal && <div className="modal-overlay" onClick={() => setOpenModal(false)} />}

          {/* Right Side Modal */}
          <div className={`slide-modal ${openModal ? "open" : ""}`}
            style={{}}>


            <div className="modal-body">
              <div className="modal-header">
                <p style={{ marginBottom: '0px', fontSize: '18px', fontWeight: 600 }}>Start New Offboarding</p>
                <Icon icon="mdi:close" width="24" onClick={() => setOpenModal(false)} className="close-btn" />
              </div>


         

              {/* Employee */}
              <label className="label">Select Employee*</label>
              <div className="input-box" style={{ position: "relative" }}>
                <Icon icon="mdi:magnify" width="20" color="#A0A0A0" />
                <input
                  type="text"
                  className="form-control"
                  name="employee"
                  placeholder="Search by Name / Id"
                  value={formData.employee}
                  onChange={(e) => {
                    handleChange(e);
                    searchEmployee(e.target.value);
                  }}
                />
                <Icon icon="mdi:chevron-down" width="20" color="#A0A0A0" />

                {showEmployeeDropdown && employeeList.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "45px",
                      left: 0,
                      width: "100%",
                      background: "#fff",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                      borderRadius: "8px",
                      zIndex: 10,
                    }}
                  >
                    {employeeList.map((emp) => (
                      <p
                        key={emp.empId}
                        style={{
                          margin: 0,
                          padding: "10px 12px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setFormData({
                            ...formData,
                            employee: `${emp.firstName} ${emp.lastName}`,
                          });
                          setSelectedEmployee(emp);
                          setShowEmployeeDropdown(false);
                          setEmployeeList([]);
                        }}
                      >
                        {emp.firstName} {emp.lastName} ({emp.empId})
                      </p>
                    ))}
                  </div>
                )}
              </div>
              {errors.employee && <p className="text-danger">{errors.employee}</p>}


              {/* LWD */}
              <label className="label">Last Working day*</label>
             
              <div className="input-box">
  <DatePicker
    selected={
      formData.lastWorkingDay
        ? new Date(formData.lastWorkingDay)
        : null
    }
    onChange={(date) => {
      if (!date) return;
      handleChange({
        target: {
          name: "lastWorkingDay",
          value: date.toISOString().split("T")[0],
        },
      });
    }}
    dateFormat="yyyy-MM-dd"
    customInput={
      <div className="date-input-ui">
        <span className="date-text">
          {formData.lastWorkingDay
            ? formData.lastWorkingDay.split("-").reverse().join("/")
            : "DD/MM/YYYY"}
        </span>
        <Icon icon="uil:calendar" className="date-icon" />
      </div>
    }
  />
</div>

              {errors.lastWorkingDay && <p style={{ color: "red", fontSize: "12px", marginBottom: '-10px' }}>{errors.lastWorkingDay}</p>}

              {/* Offboarding Type */}
              <label className="label">Offboarding type*</label>
              <div className="radio-row" style={{ gap: '8px' }}>
                <label>
                  <input
                    type="radio"
                    name="offboardingType"
                    value="Resignation"
                    checked={formData.offboardingType === "Resignation"}
                    onChange={handleChange}
                  />   Resignation
                </label>
                <label>
                  <input
                    type="radio"
                    name="offboardingType"
                    value="Termination"
                    checked={formData.offboardingType === "Termination"}
                    onChange={handleChange}
                  />  Termination
                </label>
              </div>
              {errors.offboardingType && <p style={{ color: "red", fontSize: "12px", marginBottom: '-10px' }}>{errors.offboardingType}</p>}

              {/* Reason */}
              <label className="label">Reason for Leaving*</label>
              <div className="input-box">
                <input
                  type="text"
                  className='form-control'
                  name="reason"
                  placeholder="Select reason"
                  value={formData.reason}
                  onChange={handleChange}
                  onClick={() => setShowReasonDropdown(!showReasonDropdown)}
                />
                <Icon icon="mdi:chevron-down" width="20" color="#A0A0A0" />
                {showReasonDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "45px",
                      left: 0,
                      width: "100%",
                      background: "#fff",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                      borderRadius: "8px",
                      zIndex: 10,
                      padding: "10px 0",
                    }}
                  >
                    {reasonOptions.map((item, index) => (
                      <p
                        key={index}
                        onClick={() => {
                          setFormData({ ...formData, reason: item });
                          setShowReasonDropdown(false);
                        }}
                        style={{
                          margin: 0,
                          padding: "10px 12px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                      >
                        {item}
                      </p>
                    ))}
                  </div>
                )}
              </div>
              {errors.reason && <p style={{ color: "red", fontSize: "12px", marginBottom: '-10px' }}>{errors.reason}</p>}

              {/* Notes */}
              <label className="label">Additional Notes</label>
              <div style={{ height: '55px', marginBottom: '2px' }}>

                <textarea

                  className="notes-box form-control"
                  name="notes"
                  placeholder="Add any additional information"
                  value={formData.notes}
                  onChange={handleChange}
                ></textarea>
              </div>
              {errors.notes && <p style={{ color: "red", fontSize: "12px", marginBottom: '-10px' }}>{errors.notes}</p>}



              {/* Footer */}
              <div className="modal-footer" style={{ marginTop: '15px' }}>
                <button className="cancel-btn" onClick={() => setOpenModal(false)}>Cancel</button>
                <button className="create-btn" onClick={handleSubmit}>
                  Create Request
                </button>

              </div>

            </div>



          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Offboarding